export default __webpack_public_path__ + "images/73ae084c7d96518098c602029f862e36.png";